import { profilePath } from "@travily/routes";
import type {
  ListingsCardPhotosTrait,
  ListingsCardPhotoTrait,
  ListingsCardSellerTrait,
} from "@travily/types/models/ListingsCard";
import type ImageType from "@travily/types/shared/Image";
import type { ListingCardAuthor } from "./ListingCard";

type WithOptionalPhotos = Partial<ListingsCardPhotosTrait & ListingsCardPhotoTrait>;
type WithOptionalSeller = Partial<ListingsCardSellerTrait>;

/** Resolves the single cover image from a listing's photo or photos field. */
export function resolveListingImage(listing: WithOptionalPhotos): ImageType | null {
  if ("photo" in listing && listing.photo) return listing.photo;
  if ("photos" in listing) return listing.photos?.[0]?.image ?? null;
  return null;
}

/** Resolves all images from a listing's photos field for carousel rendering. */
export function resolveListingImages(listing: WithOptionalPhotos): ImageType[] {
  if (!("photos" in listing) || !listing.photos) return [];
  return listing.photos.map((p) => p.image).filter((img): img is ImageType => img != null);
}

/** Resolves the seller author info from a listing's account field. */
export function resolveListingAuthor(listing: WithOptionalSeller): ListingCardAuthor | undefined {
  if (!("account" in listing) || !listing.account) return undefined;
  const account = listing.account;
  return {
    avatar: account.avatar,
    profile_type: account.profile_type,
    href: profilePath(account.handle ?? ""),
    initial: account.initial ?? "",
    name: account.display_name ?? "",
  };
}
